export const DEFAULT_QUERY_OPTIONS = {
  // ensures that the query will return partial data even if some of the data is missing so that the UI won't error
  errorPolicy: 'all',
  // ensures that the query will update the UI when new requests are made
  notifyOnNetworkStatusChange: true
};
export const EMPTY_VALUE = '--';
export const ContractStatus = Object.freeze({
  Active: 'active',
  Completed: 'completed',
  Terminated: 'terminated',
  Draft: 'draft'
});
export const ObjectSource = Object.freeze({
  API: 'API',
  CRM_UI: 'CRM_UI'
});